import { useEffect, useMemo, useState } from "react";

import { useParams, useSearchParams } from "react-router-dom";

import downloadFile from "@app/analytics/ReportFileDownload/downloadFile";
import useTopicReport from "@app/analytics/TopicReport/hooks/useTopicReport";
import useTopicReportEntities from "@app/analytics/TopicReport/hooks/useTopicReportEntities";
import { generateSummaryTextFile } from "@app/analytics/TopicReport/utils";
import useAuth from "@app/common/auth/useAuth";
import ROUTES from "@app/common/routes";
import usePageTitle from "@app/utils/hooks/usePageTitle";

import FileDownload from "./FileDownload";

const TopicSummaryDownload = () => {
  usePageTitle("Topic Summary Download");

  const { user } = useAuth();
  const { topicId } = useParams();
  const [searchParams] = useSearchParams();
  const impersonateId = searchParams.get("iid");

  const [downloaded, setDownloaded] = useState(false);

  const {
    topic,
    isLoading: isTopicReportLoading,
    isError: isTopicReportError,
  } = useTopicReport();
  const {
    isLoading: isTopicReportEntitiesLoading,
    isError: isTopicReportEntitiesError,
    ...entities
  } = useTopicReportEntities();

  const isLoading = isTopicReportLoading || isTopicReportEntitiesLoading;
  const isError =
    isTopicReportError || isTopicReportEntitiesError || (!isLoading && !topic);

  const txtFile = useMemo(() => {
    if (isLoading || isError || !topic) return "No summary available";

    return generateSummaryTextFile(topic, entities);
  }, [topic, isLoading]);

  useEffect(() => {
    if (isLoading || !topic || downloaded) return;
    setDownloaded(true);
    downloadFile(txtFile, "summary", topic.title);
  }, [isLoading, downloaded, txtFile, topic]);

  return (
    <FileDownload
      title="summary"
      loading={isLoading}
      error={isError}
      reportUrl={ROUTES.topicReportById(topicId!, impersonateId ?? user!.id)}
    />
  );
};

export default TopicSummaryDownload;
